import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import Currency from "../../models/Currency";

class CurrencySearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currencies: [],
            term: "",
            existing: [],
            searchTimer: null,
        };

        this.additionalQueryParams = {};
        if (this.props.active === true) {
            this.additionalQueryParams.active = true;
        }
    }

    async componentDidMount() {
        if ((this.props.value ?? null) === null) return;
        const include = Array.isArray(this.props.value)
            ? this.props.value
            : [this.props.value];
        if (include.length === 0) return;
        const currencies = await Currency.list({
            include,
        });
        this.setState({ existing: currencies, currencies });
    }

    async load() {
        const { term } = this.state;
        let exclude = this.props.value;
        if (Array.isArray(exclude) === false) {
            exclude = [exclude];
        }

        return Currency.list(
            Object.assign({ term, exclude }, this.additionalQueryParams)
        );
    }

    onChangeSearch(value) {
        this.setState({ term: value });

        if (this.isLoading) {
            clearTimeout(this.state.searchTimer);
        }

        if (value.length === 0) {
            return this.setState({ searchTimer: null });
        }

        const searchTimer = setTimeout(async () => {
            const currencies = await this.load();
            clearTimeout(this.state.searchTimer);
            return this.setState({
                searchTimer: null,
                currencies: currencies.concat(this.state.existing),
            });
        }, 1000);

        this.setState({ searchTimer });
    }

    emptyListMessage() {
        if (this.isLoading) {
            return "Searching...";
        }

        if (this.state.term.length === 0) {
            return "Type to search for currencies";
        }

        return "No currencies found";
    }

    onChange(value) {
        const compareValue = Array.isArray(value) ? value : [value];
        const newExisting = [];
        for (const id of compareValue) {
            const existing = newExisting.some(({ _id }) => _id === id);
            if (existing === false) {
                const add =
                    this.state.currencies.find(({ _id }) => _id === id) ?? null;
                newExisting.push(add);
            }
        }

        this.setState({
            term: "",
            existing: newExisting,
            currencies: newExisting,
        });
        this.props.onChange(value);
    }

    get isLoading() {
        return this.state.searchTimer !== null;
    }

    dropdownOptions() {
        const options = this.state.currencies.map((currency, i) => ({
            key: i,
            text: `${currency.symbol}${currency.name}`,
            value: currency._id,
        }));

        return options;
    }

    render() {
        return (
            <Select
                placeholder={
                    this.props.placeholder ?? "Search for currencies..."
                }
                icon="search"
                selection
                loading={this.isLoading}
                value={this.props.value}
                onSearchChange={({ target }) =>
                    this.onChangeSearch(target.value)
                }
                onChange={(_, props) => this.onChange(props.value)}
                search={(i) => i}
                multiple={this.props.multiple}
                options={this.dropdownOptions()}
                noResultsMessage={this.emptyListMessage()}
                disabled={this.props.disabled ?? false}
                fluid={this.props.fluid ?? false}
                className={"pr-2 " + this.props.className ?? ""}
            />
        );
    }
}

export default CurrencySearchSelect;
